import React, { useState, useEffect } from 'react';
import { Box, Grid, Typography } from "@mui/material";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { generateNewUsersMetrics } from '../../utilityFunctions/DataloveUtil';
import Swal from 'sweetalert';
import CustomLoader from "../../components/CustomLoader";

export default function NewUsersChart(props) {
    const { loginUser } = props;
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchNewUsersMetrics = async () => {
            setLoading(true);
            const newUsersMetrics = await generateNewUsersMetrics(loginUser.jwtToken);
            setLoading(false);

            if (!newUsersMetrics) {
                Swal({
                    title: "Error",
                    text: "Failed to fetch new users metrics",
                    icon: "error",
                    button: "Ok",
                });
                return;
            }

            // Sort the data chronologically by month
            const sortedData = (newUsersMetrics.chartData || []).sort((a, b) => {
                return a.month.localeCompare(b.month);
            });

            setData(sortedData);
        };
        fetchNewUsersMetrics();
    }, [loginUser.jwtToken]);

    return (
        <Box sx={{ display: "flex", justifyContent: "center", width: "100%", height: "100%" }}>
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: {xs: "start", sm: "start", md: "center"}, width: "95%", height: "90%", textAlign: "center", marginTop: { xs: "4.5rem", sm: "2rem", md: "0" } }}>
                {loading ? (
                    <CustomLoader />
                ) : (
                    <Grid container direction="row" spacing={1} sx={{display: "flex", justifyContent: "center"}}>
                        <Grid item xs={12}>
                            <Typography variant="h4" sx={{ marginTop: "2rem", fontWeight: "bold" }}>New Users by Registration Method</Typography>
                        </Grid>
                        {data && data.length > 0 ? (
                            <Grid item xs={12} sx={{width: "100%", height: 400}}>
                                <ResponsiveContainer width="100%" height={400}>
                                    <BarChart
                                        data={data}
                                        margin={{
                                            top: 20,
                                            right: 30,
                                            left: 20,
                                            bottom: 5,
                                        }}
                                    >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis 
                                            dataKey="month" 
                                            angle={-45} 
                                            textAnchor="end" 
                                            height={70}
                                            tick={{fontSize: 12}}
                                        />
                                        <YAxis 
                                            label={{ 
                                                value: 'Users', 
                                                angle: -90, 
                                                position: 'insideLeft',
                                                style: { textAnchor: 'middle' }
                                            }}
                                        />
                                        <Tooltip />
                                        <Legend />
                                        <Bar name="Web" dataKey="webCount" fill="#01929b" />
                                        <Bar name="Mobile" dataKey="mobileCount" fill="#4a3596" />
                                        <Bar name="Referral" dataKey="referralCount" fill="#f2736a" />
                                        <Bar name="Walk-In" dataKey="walkInCount" fill="#ffc658" />
                                    </BarChart>
                                </ResponsiveContainer>
                            </Grid>
                        ) : (
                            <Grid item xs={12}>
                                <Typography variant="body1">
                                    No data available.
                                </Typography>                                
                            </Grid>
                        )}
                    </Grid>
                )}           
            </Box>
        </Box>
    );
} 